<template>
    <div id="tumour">
        <div id="imageBox" ref="image">
            <img
                @load="imageOnload"
                class="image"
                src="~@/assets/tumour_banner.jpeg"
                alt=""
            />
        </div>

        <van-tabs v-model="active" color="green">
            <van-tab title="ONIVYDE">
                <div class="onivyde">
                    <div class="title">关于NAPOLI-1</div>
                    <div class="p">
                        国际多中心，非盲Ⅲ期临床试验，三臂临床试验。417例前期使用过吉西他滨为基础化疗的转移性胰腺癌患者按1：1：1随机接受以下方案治疗，其中：33%亚裔人群，22%台湾地区人群。
                    </div>
                    <div class="p">
                        使用5-氟尿嘧啶和纳米脂质体伊立替康，以5-氟尿嘧啶为对照组，没有设安慰剂对照。与使用5-氟尿嘧啶相比，中位OS：6.1个月 VS 4.2个月基于NAPOLI-1研究的结果，2015年6月伊立替康脂质体注射液获得优先审评；2015年10月，Onivyde伊立替康脂质体注射液+5-氟尿嘧啶/亚叶酸方案作为吉西他滨耐药的转移性胰腺癌化疗新方案获FDA批准上市。
                    </div>
                    <div class="p">
                        伊立替康脂质体注射液+5-氟尿嘧啶/亚叶酸是唯一获批的用于转移性胰腺癌的二线治疗品牌疗法；已在美国、欧洲、韩国、日本等多地市场上市。
                    </div>
                    <div class="link" @click="link">
                        了解更多
                    </div>
                </div>
                <div class="line"></div>
                <div class="onivyde">
                    <div class="ms-title">被国内外各大指南广泛推荐</div>
                    <div>
                        <img src="~@/assets/ad.png" alt="">
                    </div>
                </div>
                
            </van-tab>
            <van-tab title="慢性静脉疾病业务">
                <div class="zong scrollBox" :style="{ height: scrollHeight }">
                    <div class="title">
                        我们
                    </div>
                    <div>
                        <div>……关爱那些正在遭受癌症疾病困扰的人们。</div>
                        <div>……致力于改进治疗手段，以此来满足患者需求。</div>
                        <div>
                            ……努力确保那些需要我们药物产品的人，能够真正获得它们。
                        </div>
                        <div>……相信共同创造是对抗癌症的根本要素。</div>
                        <div>
                            ……是独立的，由一家非营利基金会管理，这确保我们能将患者的需求置于首位。
                        </div>
                    </div>
                    <div class="title">
                        关键数据
                    </div>
                    <div>
                        <div>2015年，施维雅集团涉足肿瘤学领域</div>
                        <div>
                            2018-19年度，36%的集团研发预算投入到肿瘤学领域
                        </div>
                        <div>在实体肿瘤和血液肿瘤领域，拥有 6 款已上市产品</div>
                        <div>
                            12个以胃肠道和其他实体肿瘤以及白血病和淋巴瘤为目标的肿瘤学临床研发项目
                        </div>
                        <div>
                            50个国家的700名员工全力投入，为肿瘤学领域带来创新的治疗方案
                        </div>
                        <div>
                            17个肿瘤学领域研究战略联盟
                            17个肿瘤学领域药物开发项目
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="新闻">
                <div class="news scrollBox" :style="{ height: scrollHeight }">
                    <div
                        class="item"
                        v-for="item in List"
                        :key="item.id"
                        @click="goUrl(item)"
                    >
                        
                        <div class="text">{{ item.title }}</div>
                        <div class="image-box">
                            <img class="image" :src="item.img_url" alt="" />
                        </div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import { apiAxios } from "../../fetch/api"

export default {
    name: "tumour",
    data() {
        return {
            active: 2,
            List: [],
            scrollHeight: 0,
        }
    },
    mounted() {
        apiAxios("GET", "/customer/questions", {
            module: 6,
            category: "news",
        }).then((res) => {
            if (res.data && res.data.data) {
                this.List = res.data.data
            }
        })
    },
    methods: {
        imageOnload() {
            this.$nextTick(() => {
                if (
                    document.documentElement.clientHeight <
                    this.$refs.image.offsetHeight
                ) {
                    this.scrollHeight = "auto"
                    return
                }
                this.scrollHeight = `calc(100vh - ${this.$refs.image.offsetHeight}px - 35px)`
            })
        },
        goUrl(item) {
            if (item.redirect_url) {
                window.location.href = item.redirect_url
            } else {
                this.$router.push(`/new?newId=${item.id}`)
            }
        },
        link() {
            window.location.href = "https://www.servier.com.cn/oncology"
        },
    },
}
</script>

<style lang="scss" scoped>
#tumour {
    // max-width: 1200px;
    margin: 0 auto;
    .image {
        width: 100%;
    }

    .van-tabs--line {
        padding-top: 0;
    }

    .van-hairline--top-bottom::after {
        border: none;
    }

    .van-tab--disabled {
        color: #323233;
    }

    .scrollBox {
        overflow: scroll;
    }

    .zong {
        background-color: #6dc7dd;
        color: #ffffff;
        text-align: center;
        font-size: 28px;
        box-sizing: border-box;
        padding: 100px 30px;
        line-height: 70px;
        .title {
            font-size: 50px;
            margin: 40px 0 50px;
        }
    }
    .item {
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        .image-box {
            flex: 0 0 200px;
            .image {
                border-radius: 8px;
                height: 130px;
            }
        }

        .text {
            font-size: 28px;
            flex: 1;
            margin-right: 30px;
        }
    }

    .onivyde {
        box-sizing: border-box;
        padding: 47px 33px;
        .title {
            color: #272829;
            font-size: 34px;
            margin-bottom: 30px;
            font-weight: bold;
        }
        .p {
            font-size: 26px;
            line-height: 50px;
            color: #272829;
            margin-bottom: 40px;
        }
        .link {
            height:80px;
            line-height: 80px;
            background:rgba(132,186,203,1);
            opacity:1;
            font-size: 22px;
            text-align: center;
            color: #ffffff;
            border-radius:7px;
        }
        .ms-title {
            color: #272829;
            font-size: 34px;
            font-weight: bold;
        }
    }
    .line {
        height: 9px;
        background-color: #F4F4F4;
    }

}
@media screen and (min-width: 1200px) {
    #tumour {
        .news {
            display: flex;
            flex-wrap: wrap;
        }
        .item {
            box-sizing: border-box;
            padding: 20px;
            width: 33.3%;
            display: block;
            .image-box {
                .image {
                    border-radius: 8px;
                    height: calc(100vw / 5);
                }
            }
            .text {
                font-size: 28px;
            }
        }
    }
}
</style>
